module.exports = __webpack_public_path__ + "static/media/timeline-icon.10d80e19.svg";